'use client'

import NextLink from '@/components/NextLink';
import Modal from '@/components/ui/Modal';
import { currencies } from '@/constants/currencies';
import { useAuthenticationModalStore } from '@/core/stores/auth';
import { useUserStore } from '@/core/stores/user';
import { generateAvatar } from '@/utils/generateAvatar';
import { faUser } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AnimatePresence } from "framer-motion";
import Cookies from 'js-cookie';
import Image from "next/image";
import { usePathname, useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import { HamburgerMenu, UserCircle } from 'solar-icon-set';
import useAppStore from '@/core/stores/app';
import dynamic from 'next/dynamic';
import ImageLoading from '@/components/ImageLoading';
import Spinner from '@/components/ui/Spinner';

const Sidebar = dynamic(() => import('./SideBar'))

export default function HeaderNavigation({ }: { assetUrl?: string, hasUserToken?: boolean, }) {

    const { setShowAuthModal } = useAuthenticationModalStore()
    const [currency, setCurrency] = useState('USD')
    const [showCurrencies, setShowCurrencies] = useState(false)


    const { isApp } = useAppStore()
    const { email, image, _id, isGettingProfile } = useUserStore()

    const router = useRouter()
    const pathname = usePathname()
    const [show, setShow] = useState(false)

    const [hasUserToken, setHasUserToken] = useState<string>();
    const token = Cookies.get('ut')

    useEffect(() => {
        if (token) {
            setHasUserToken(token);
        }
    }, [token]);



    useEffect(() => {
        setCurrency(Cookies.get('currency') || 'USD')
    }, [])

    const handleClick = (currency: string) => {
        Cookies.set('currency', currency);
        setCurrency(currency)
        router.refresh()
        window.location.reload()
    };


    return (
        <div className='flex flex-col w-full'>

            <div className={`${`bg-transparent`}
                 md:hidden  relative z-20 
                   mx-auto  w-full pt-3.5 pb-2`}
            >
                <div className='my-container grid grid-cols-[24px,_1fr,_28px]'>
                    {!isApp ? <button
                        aria-label='show-burger-menu'
                        onClick={() => setShow(true)}>
                        <HamburgerMenu className='w-8 text-secondary-500' size={24} />
                    </button> : <span></span>}
                    <div className="flex flex-row justify-center items-center gap-2 ">
                        <NextLink scroll={true} href={"/"} className="font-semibold sm:text-2xl flex items-center gap-2">
                            <Image className='rounded w-7 lg:w-9 object-cover' width={300} height={300} alt='planingo-Masqat'
                             src={`${process.env.NEXT_PUBLIC_STORAGE_URL}assets/294831b9-b06f-49c3-b532-755dd9b2ab98-planingo.png`} />
                            <span className='font-extrabold flex'>Planin<span className='text-primary-600 w-4 block tracking-tighter font-extrabold'> Go</span></span>
                        </NextLink>
                    </div>
                    <div className=" flex-row items-center  text-sm font-medium text-gray-800 flex">
                        {/* <div className='relative border-r border-indigo-500 px-2'>
                            <button onClick={() => setShowCurrencies(s => !s)}
                                className={` text-transparent bg-purple-banner bg-clip-text  text-xs rounded-md px-1.5 py-0.5`}>
                                <span className='pe-1'>{currencies[currency!]}</span>
                                {currency}
                            </button>
                            <Modal identifier='currencies' isFull show={showCurrencies} onClose={() => setShowCurrencies(false)} title='Select Your Currency'>
                                <div className='flex flex-col text-sm'>
                                    <div onClick={(e) => {
                                        e.stopPropagation()
                                        handleClick('EUR')
                                    }} className={`${currency === 'EUR' ? 'text-indigo-500' : 'text-neutral-700'}
    items-center py-2.5 grid gap-2 grid-cols-[1fr,_auto] cursor-pointer `}>
                                        <span>EUR - Euro</span>
                                    </div>
                                    <div onClick={(e) => {
                                        e.stopPropagation()
                                        handleClick('USD')
                                    }} className={`${currency === 'USD' ? 'text-indigo-500' : 'text-neutral-700'}
    items-center py-2.5 grid gap-2 grid-cols-[1fr,_auto] cursor-pointer `}>
                                        <span>USD - United States Dollar ($)</span>
                                    </div>

                                    <div onClick={(e) => {
                                        e.stopPropagation()
                                        handleClick('GBP')
                                    }} className={`${currency === 'GBP' ? 'text-indigo-500' : 'text-neutral-700'}
    items-center py-2.5 grid gap-2 grid-cols-[1fr,_auto] cursor-pointer `}>
                                        <span>GBP - British Pound</span>
                                    </div>

                                </div>
                            </Modal>

                        </div> */}

                        <AnimatePresence>
                            {_id ?
                                <div className="relative pl-2">
                                    <NextLink href={'/profile'} className=" z-50 flex flex-row gap-2 items-center">
                                        <span className='size-7  rounded-full '>
                                            {(email || image) && <ImageLoading width={100} height={100} src={image || generateAvatar(email)}
                                                className="object-cover w-full h-full rounded-full " alt="Planingo" />}
                                        </span>
                                    </NextLink>

                                </div> : isGettingProfile ?
                                    <span className='size-7  rounded-full '>
                                        <Spinner />
                                    </span>
                                    :
                                    <button onClick={() => setShowAuthModal(true)}
                                        className="text-secondary-500"
                                        aria-label='open-auth-modal'
                                    >
                                        <UserCircle size={24} />
                                    </button>
                            }
                        </AnimatePresence>

                    </div>
                </div>
            </div>
            {/* <div className='relative z-10 w-full md:hidden'>
                <div className='absolute left-0 w-full top-0'>

                    <IntroBanner />
                </div>
            </div> */}
            <Sidebar setShow={setShow} show={show} />
        </div>

    )
}